var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "holiday-main-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow02.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "right",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "tit-right",
                      on: { click: _vm.handleToRule },
                    },
                    [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/rules02.png"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "national-con",
        style: { "margin-top": `-${_vm.barHeight + 46}px` },
      },
      [
        _c("div", { staticClass: "national-head" }, [
          _c("img", {
            staticClass: "head-img-back",
            attrs: { src: require("./images/main-bg.png") },
          }),
          _c("div", { staticClass: "head-img" }, [
            _vm.$i18n.locale === "es"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-es") } })
              : _vm.$i18n.locale === "pt"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-pt") } })
              : _vm.$i18n.locale === "ar"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-ar") } })
              : _vm.$i18n.locale === "tr"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-tr") } })
              : _vm.$i18n.locale === "fr"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-fr") } })
              : _vm.$i18n.locale === "id"
              ? _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-id") } })
              : _c("img", { attrs: { src: _vm.getMatchTitle("tit-bg-en") } }),
          ]),
        ]),
        _c("div", { staticClass: "main-con" }, [
          _c(
            "div",
            { staticClass: "act-date" },
            [
              _vm.actInfo
                ? [
                    !_vm.actInfo.started
                      ? _c("div", { staticClass: "act-enddate" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.commonM.k205")) + " "
                          ),
                          _c("i", [
                            _vm._v(
                              _vm._s(_vm.countdownResult.hours) +
                                ":" +
                                _vm._s(_vm.countdownResult.minutes) +
                                ":" +
                                _vm._s(_vm.countdownResult.seconds)
                            ),
                          ]),
                        ])
                      : _c("div", { staticClass: "act-enddate" }, [
                          _vm._v(
                            _vm._s(_vm.mexActStartTime) +
                              " - " +
                              _vm._s(_vm.mexActEndTime)
                          ),
                        ]),
                  ]
                : _vm._e(),
              _c("div", { staticStyle: { height: "12px" } }),
              _c("div", { staticClass: "act-range" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k333"))),
              ]),
            ],
            2
          ),
          _vm.actInfo && !!_vm.actInfo.started
            ? _c("div", { staticClass: "points-rank" }, [
                _c("div", { staticClass: "pr-item" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k221")))]),
                  _vm.actInfo
                    ? _c("div", [_vm._v(_vm._s(_vm.actInfo.score || 0))])
                    : _vm._e(),
                ]),
                _c("div", { staticStyle: { width: "15px" } }),
                _c(
                  "div",
                  { staticClass: "pr-item" },
                  [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k222")))]),
                    _vm.actInfo
                      ? [
                          !_vm.actInfo.rank
                            ? _c("div", [_vm._v("--")])
                            : _c("div", [_vm._v(_vm._s(_vm.actInfo.rank))]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k218")))]),
            ]),
            _vm.actInfo && !!_vm.actInfo.started
              ? _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k244"))),
                ])
              : _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k259"))),
                ]),
            _c("div", { staticClass: "national-gift" }, [
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+1 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Pumpkin.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k334"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+3 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Ring.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k211"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+5 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/CandyBag.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k335"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+15 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Kiss.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k305"))),
                ]),
              ]),
              _c("div", { staticClass: "gift-round" }, [
                _c("div", { staticClass: "gift-cost" }, [
                  _vm._v("+50 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Treasure.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "gift-name" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k306"))),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k215")))]),
            ]),
            _c("div", { staticClass: "part-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k216"))),
            ]),
            _c("div", { staticClass: "part-percent" }, [
              _c("div", { staticClass: "part-per-block" }, [
                _c("div", [
                  _c("div", { staticClass: "part-per-tips" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k217")))]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.percentData.percent1.num) + "/10"),
                    ]),
                  ]),
                  _c("div", { staticClass: "part-per-bar" }, [
                    _c("div", {
                      staticClass: "part-per-track",
                      style: { width: `${_vm.percentData.percent1.rate}%` },
                    }),
                  ]),
                ]),
                _c("div", { staticStyle: { width: "100%", height: "20px" } }),
                _c("div", [
                  _c("div", { staticClass: "part-per-tips" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k217")))]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.percentData.percent2.num) + "/15"),
                    ]),
                  ]),
                  _c("div", { staticClass: "part-per-bar" }, [
                    _c("div", {
                      staticClass: "part-per-track",
                      style: { width: `${_vm.percentData.percent2.rate}%` },
                    }),
                  ]),
                ]),
                _c("div", { staticStyle: { width: "100%", height: "20px" } }),
                _c("div", [
                  _c("div", { staticClass: "part-per-tips" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k217")))]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.percentData.percent3.num) + "/20"),
                    ]),
                  ]),
                  _c("div", { staticClass: "part-per-bar" }, [
                    _c("div", {
                      staticClass: "part-per-track",
                      style: { width: `${_vm.percentData.percent3.rate}%` },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticStyle: { width: "10px" } }),
              _c("div", { staticClass: "part-per-reward" }, [
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.percentData.percent1.reward) + " "),
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                ]),
                _c("div", { staticStyle: { width: "100%", height: "20px" } }),
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.percentData.percent2.reward) + " "),
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                ]),
                _c("div", { staticStyle: { width: "100%", height: "20px" } }),
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.percentData.percent3.reward) + " "),
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k218")))]),
            ]),
            _c("div", { staticClass: "part-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k219"))),
            ]),
            _c("div", { staticClass: "national-reward" }, [
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.1")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num1Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.2")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num2Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.3")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num3Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "national-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.4-10")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num4Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
            ]),
            _vm.actInfo && _vm.actInfo.started
              ? _c("div", { staticClass: "btn-block" }, [
                  _c(
                    "div",
                    {
                      staticClass: "national-btn",
                      on: { click: _vm.handleToRank },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.commonM.k220")))]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm.actInfo && !_vm.actInfo.started
            ? _c("div", { staticClass: "btn-block" }, [
                _c(
                  "div",
                  {
                    staticClass: "national-btn",
                    on: { click: _vm.handleGotIt },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.gotit")))]
                ),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }